import WmsLayer from './WmsLayer';
import { kowrAttribution } from './attribution';

export default class KowrLayer extends WmsLayer {
    static ID = 'kowr';
    static DESCRIPTION = 'Działki w zasobie Krajowego Ośrodka Wsparcia Rolnictwa';
    static MIN_ZOOM = 5;
    static FEATURE_INFO_MIN_ZOOM = 14;
    static WMS_URL = 'https://mapy.geoportal.gov.pl/wss/ext/kowr';

    clear() {
        super.clear();
        this.clearPointerCursor();
    }

    syncPointerCursor() {
        const map = this.getMap();
        if (!map || !map.getCanvas()) {
            return;
        }

        if (this.canQueryFeatureInfo()) {
            map.getCanvas().style.cursor = 'pointer';
            this.pointerCursorActive = true;
            return;
        }

        this.clearPointerCursor();
    }

    getWmsConfig() {
        return {
            url: KowrLayer.WMS_URL,
            params: {
                // MapServer selects one representation using the scale ranges
                // declared by KOWR: województwa, powiaty, parcel-location
                // counters, then exact parcel boundaries.
                LAYERS: 'wojewodztwa,powiaty,dzialki_pkt,dzialki',
                FORMAT: 'image/png',
                TRANSPARENT: 'true',
                VERSION: '1.1.1'
            },
            opacity: 0.86,
            attribution: kowrAttribution()
        };
    }

    canQueryFeatureInfo() {
        const map = this.getMap();
        return this.isActive() && !!map && map.getZoom() >= KowrLayer.FEATURE_INFO_MIN_ZOOM;
    }

    async getFeatureInfo(latlng, options = {}) {
        if (!this.canQueryFeatureInfo() || !latlng) {
            return null;
        }

        if (this.featureInfoController) {
            this.featureInfoController.abort();
        }
        this.featureInfoController = new AbortController();
        const controller = this.featureInfoController;
        const abort = () => controller.abort();
        if (options.signal) {
            options.signal.addEventListener('abort', abort, { once: true });
            if (options.signal.aborted) abort();
        }
        const timer = setTimeout(abort, 15000);

        const query = new URLSearchParams({
            lat: Number(latlng.lat).toFixed(7),
            lng: Number(latlng.lng).toFixed(7)
        });
        const baseUrl = String(this.config.baseUrl || '/');
        const url = baseUrl.replace(/\/?$/, '/') + 'api/kowr/feature-info?' + query.toString();

        if (this.config.onRequestStarted) this.config.onRequestStarted();
        try {
            const response = await fetch(url, {
                headers: { Accept: 'application/json' },
                signal: controller.signal
            });
            if (!response.ok) {
                throw new Error('KOWR feature info HTTP ' + response.status);
            }
            return await response.json();
        } finally {
            clearTimeout(timer);
            if (options.signal) options.signal.removeEventListener('abort', abort);
            if (this.featureInfoController === controller) this.featureInfoController = null;
            if (this.config.onRequestSettled) this.config.onRequestSettled();
        }
    }

    abortFeatureInfo() {
        if (this.featureInfoController) {
            this.featureInfoController.abort();
            this.featureInfoController = null;
        }
    }

    clearPointerCursor() {
        const map = this.getMap();
        if (!map || !map.getCanvas() || !this.pointerCursorActive) {
            return;
        }

        if (map.getCanvas().style.cursor === 'pointer') {
            map.getCanvas().style.cursor = '';
        }
        this.pointerCursorActive = false;
    }
}
